import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
export var StyledAccordionListContainer = styled.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    max-width: 800px;\n    width: 100%;\n"], ["\n    max-width: 800px;\n    width: 100%;\n"])));
var templateObject_1;
